<template>
  <div id="app">
    <nav class="navbar navbar-inverse navbar-fixed-top">
      <div class="container">
        <div class="navbar-header">
          <a
            class="navbar-brand"
            href="/"
          ><span class="title">C19UDM - Urban Dynamic Model</span>
            <span class="beta">Beta test version</span>
          </a>
        </div>
        <ul class="nav navbar-nav navbar-right">
          <li>
            <a
              href="http://www.steerdaviesgleave.com"
              target="_blank"
            >
              <i class="steer-davies-gleave" />
            </a>
          </li>
        </ul>
      </div>
    </nav>
    <main
      id="content"
      class="content"
      role="main"
    >
      <router-view />
    </main>
    <nav class="navbar navbar-inverse navbar-footer">
      <div class="container">
        <div class="udm-footer">
          <div class="col-md-6">
            <h3>Contact us</h3>
            <p>
              If you would like to know how the Urban Dynamic Model could help
              your town, city or region, please get in touch via the contact
              form.
            </p>
            <p class="primary-button">
              <a
                href
                class="btn btn-primary btn-border"
                @click.prevent="displayModal('contact')"
              >Contact us</a>
            </p>
          </div>
          <div class="clearfix" />
        </div>
      </div>
      <div class="container forio-logo-container">
        <a
          href="https://forio.com"
          class="forio-logo"
          target="_blank"
        >forio</a>
      </div>
    </nav>
    <AboutModalComponent />
    <ContactModalComponent />
    <ModelInfoModalComponent />
    <CovidStatusInfoModalComponent />
    <RunMultipleStepsDialogComponent />
    <DeleteSavedRunDialogComponent />
    <NameSavedRunDialogComponent />
    <div class="floating-button">
      <div class="text-center">
        <a
          href="#"
          class="smooth-scroll button"
          @click.prevent="scrollToTop"
        >
          <span class="glyphicon glyphicon-chevron-up" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import AboutModalComponent from "./components/modals/About.vue";
import ContactModalComponent from "./components/modals/Contact.vue";
import ModelInfoModalComponent from "./components/modals/ModelInfo";
import CovidStatusInfoModalComponent from "./components/modals/CovidStatusInfo";
import RunMultipleStepsDialogComponent from "./components/dialogs/RunMultipleSteps";
import DeleteSavedRunDialogComponent from "./components/dialogs/DeleteSavedRun";
import NameSavedRunDialogComponent from "./components/dialogs/NameSavedRun";
import numeral from "numeral";
import * as $ from "jquery";

numeral.register("locale", "gb", {
  delimiters: {
    thousands: ",",
    decimal: "."
  },
  abbreviations: {
    thousand: "k",
    million: "m",
    billion: "b",
    trillion: "t"
  },
  ordinal: function(number) {
    return number === 1 ? "" : "s";
  },
  currency: {
    symbol: "£"
  }
});

// Register our special thousand-format
numeral.register("format", "sdg_people", {
  regexps: {
    format: /(A)/,
    unformat: /(A)/
  },
  format: function(value, format, roundingFunction) {
    format = format.replace(/\s?A/, "");
    if (value < 1000) {
      return numeral._.numberToFormat(value, "0", roundingFunction);
    }
    return numeral._.numberToFormat(value, format + "a", roundingFunction);
  },
  unformat: function(string) {
    return numeral._.stringToNumber(string) * 1;
  }
});

// Register our special format where the numbers is scaled at 100
// (so 1.2 -> 120)
numeral.register("format", "sdg_number_x_100", {
  regexps: {
    format: /(B)/,
    unformat: /(B)/
  },
  format: function(value, format, roundingFunction) {
    format = format.replace(/\s?B/, "");
    return numeral._.numberToFormat(value * 100, format, roundingFunction);
  },
  unformat: function(string) {
    return numeral._.stringToNumber(string) * 1;
  }
});

// switch between locales
numeral.locale("gb");

export default {
  name: "App",
  components: {
    RunMultipleStepsDialogComponent,
    DeleteSavedRunDialogComponent,
    NameSavedRunDialogComponent,
    AboutModalComponent,
    ContactModalComponent,
    ModelInfoModalComponent,
    CovidStatusInfoModalComponent
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  unmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      if ($(window).scrollTop() > 50) {
        if ($(".floating-button").is(":hidden")) {
          $(".floating-button").show(100);
        }
      } else if ($(window).scrollTop() < 50) {
        if (!$(".floating-button").is(":hidden")) {
          $(".floating-button").hide(50);
        }
      }
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    displayModal(modalName) {
      this.$root.$data.eventHub.$emit("show-" + modalName + "-modal");
    }
  }
};
</script>

<style lang="scss">
.navbar-header {
  padding: 5px 0;

  .navbar-brand {
    position: relative;

    .title {
      display: block;
      margin-top: -6px;
    }
    .beta {
      font-size: 0.7em;
      position: absolute;
      bottom: 5px;
      left: 15px;
      opacity: 0.8;
    }
  }
}
</style>
